import { useMemo } from "react";
import { useServiceContext } from "../../contexts/services/hooks/use-services-context";
import { BANNER_KEY } from "../../managers/banner/queries";
import type { BannerData } from "../../managers/banner/types/banner";
import { useSessionQuery, type LiveState } from "../session/useSessionQuery";

/** Bannière à afficher, `null` quand il n'y en a pas. */
export function useBanner(): LiveState<BannerData | null> {
    return useSessionQuery<BannerData | null>(BANNER_KEY);
}

export type BannerActions = {
    /** Revérifie la bannière affichée ; sans effet tant que la session n'est pas créée. */
    refreshBanner: () => Promise<void>;
};

export function useBannerActions(): BannerActions {
    const bannerManager = useServiceContext().sdk?.bannerManager;

    return useMemo(
        () => ({
            refreshBanner: async () => {
                await bannerManager?.refreshBanner();
            },
        }),
        [bannerManager],
    );
}
